import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../services/api.client'

export interface IdmAccMappingRecord {
	id: number
	idmGroup: string
	accGroup: string
	tool: string
	roleInTool: string | null
	provisioningMethod: string
	isElevatedAccess: boolean
	approvalRequired: boolean
	approvalOwner: string | null
	highRisk: boolean
	notes: string | null
	createdAt: string
	updatedAt: string
}

export const useIdmAccMappings = () =>
	useQuery({
		queryKey: ['idm-acc-mappings'],
		queryFn: async () => {
			const response = await apiClient.get<IdmAccMappingRecord[]>('/employees/idm-acc-mappings')
			return response.data || []
		},
	})

export const useCreateIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async (data: Omit<IdmAccMappingRecord, 'id' | 'createdAt' | 'updatedAt'>) => {
			const response = await apiClient.post<IdmAccMappingRecord>('/employees/idm-acc-mappings', data)
			return response.data
		},
		onSuccess: () => void qc.invalidateQueries({ queryKey: ['idm-acc-mappings'] }),
	})
}

export const useUpdateIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async ({ id, data }: { id: number; data: Partial<IdmAccMappingRecord> }) => {
			const response = await apiClient.put<IdmAccMappingRecord>(`/employees/idm-acc-mappings/${id}`, data)
			return response.data
		},
		onSuccess: () => void qc.invalidateQueries({ queryKey: ['idm-acc-mappings'] }),
	})
}

export const useDeleteIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async (id: number) => {
			await apiClient.delete(`/employees/idm-acc-mappings/${id}`)
		},
		onSuccess: () => void qc.invalidateQueries({ queryKey: ['idm-acc-mappings'] }),
	})
}
